/**
 * @description
 */

import Api from '../../path';
import { ECollectionType } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    obj_type: ECollectionType;
    obj_id: number;
}

export interface IOutput {
    /** 0. 未收藏；1. 已收藏 */
    status: number;
}
// 判断对象是否被收藏
export const getCollectionsIsCollected = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.IS_COLLECTED, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
